<template>
  <div v-if="program.id">
    <ProgramInfo :program="program"></ProgramInfo>

    <ProgramDestinations :program="program"></ProgramDestinations>

    <ProgramLives :program="program"></ProgramLives>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/programs/show.scss";
</style>

<script>
import ProgramInfo from "@/view/pages/programs/comp/ProgramInfo";
import ProgramDestinations from "@/view/pages/programs/comp/ProgramDestinations";
import ProgramLives from "@/view/pages/programs/comp/ProgramLives";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_PROGRAM,
  SET_PROGRAM
} from "@/core/services/store/programs.module";
import { mapGetters } from "vuex";

export default {
  name: "programs-show",
  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin")
    };
  },
  components: {
    ProgramInfo,
    ProgramDestinations,
    ProgramLives
  },
  beforeMount() {
    let programId = this.$route.params.id;

    this.$store.commit(SET_PROGRAM, {});
    this.$store.dispatch(FETCH_PROGRAM, programId).then(() => {
      this.setBreadcrumbs();
      this.setActions();
    });
  },
  computed: {
    ...mapGetters(["currentUserProperty", "program"]),
    programLoaded() {
      return this.program.id !== undefined;
    }
  },
  methods: {
    setBreadcrumbs() {
      let programsRouteName = "programs-index";

      let items = [];
      if (this.isCompany) {
        programsRouteName = "company-programs-index";

        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }
      if (this.isAdmin) {
        programsRouteName = "admin-programs-index";

        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });
      }

      items.push({ title: "برنامه‌‌ها", route: { name: programsRouteName } });
      items.push({ title: this.program.name });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let programId = this.$route.params.id;
      let programEditRouteName = "programs-edit";
      let programScheduleRouteName = "programs-schedules";
      let programsRouteName = "programs-index";

      if (this.isCompany) {
        programsRouteName = "company-programs-index";
      }

      if (this.isAdmin) {
        programsRouteName = "admin-programs-index";
      }
      let links = [
        {
          name: "بازگشت",
          to: { name: programsRouteName }
        }
      ];

      if (this.isCompany) {
        programEditRouteName = "company-programs-edit";
        programScheduleRouteName = "company-programs-schedules";
        links = [
          {
            name: '<i class="flaticon-edit"></i>ویرایش',
            to: { name: programEditRouteName, params: { id: programId } },
            class: "btn-primary"
          },
          {
            name: ' <i class=" flaticon-user ml-2  font-size-h5 "></i>',
            to: {
              name: "company-users-show",
              params: { id: this.program.user_id }
            },
            class: "btn-primary"
          },
          {
            name: "بازگشت",
            to: { name: programsRouteName }
          }
        ];
      }

      if (this.isAdmin) {
        programEditRouteName = "admin-programs-edit";
        programScheduleRouteName = "admin-programs-schedules";
        links = [
          {
            name: '<i class="flaticon-edit"></i>ویرایش',
            to: { name: programEditRouteName, params: { id: programId } },
            class: "btn-primary"
          },
          {
            name: ' <i class=" flaticon-user ml-2  font-size-h5 "></i>',
            to: {
              name: "admin-users-show",
              params: { id: this.program.user_id }
            },
            class: "btn-primary"
          },
          {
            name: "بازگشت",
            to: { name: programsRouteName }
          }
        ];
      }

      if (this.program.type !== 1) {
        let schedulemingBtn = {
          name: '<i class="flaticon2-time"></i>زمانبندی',
          to: { name: programScheduleRouteName, params: { id: programId } },
          class: "btn-primary"
        };
        links.unshift(schedulemingBtn);
      }

      this.$store.dispatch(SET_ACTIONS, {
        links: links
      });
    }
  }
};
</script>
